import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Club_PageMenu_ApiEnum } from './ClubDetailConfigApiInterface';

export enum Config_ClubPlayers_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_ClubPlayers_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'players' = 'players',
}

export enum Config_ClubPlayers_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_ClubPlayers_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_ClubPlayers_ApiInterface
    extends ConfigDataInterface<
        Config_ClubPlayers_Modules_ApiEnum,
        Config_ClubPlayers_ActionsMenu_ApiEnum,
        Config_ClubPlayers_ActionsOther_ApiEnum,
        Config_Club_PageMenu_ApiEnum,
        Config_ClubPlayers_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
